import { render, staticRenderFns } from "./MealDetails.vue?vue&type=template&id=56f46c6f&lang=pug&"
import script from "./MealDetails.vue?vue&type=script&lang=js&"
export * from "./MealDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports